<template>
  <b-card class="rounded">
    <b-form @submit="onSubmit">
      <b-form-row class="mb-3">
        <b-col class="col-3">
          <b-input-group size="sm">
            <template #append>
              <b-input-group-text>
                <i
                  class="hp-text-color-blue-100 hp-text-color-dark-0 ri-search-line"
                  style="font-size: 16px"
                ></i>
              </b-input-group-text>
            </template>
            <b-form-input
              id="filter-input"
              v-model="filter_text"
              type="search"
              placeholder="Поиск по таблице"
            ></b-form-input>
          </b-input-group>
        </b-col>

        <b-col>
          <b-button
            size="sm"
            variant="outline-primary"
            :disabled="downloading"
            @click="downloadTable"><i class="ri-file-download-line remix-icon"></i>
            <span>Выгрузить таблицу CSV</span></b-button
          >
        </b-col>
      </b-form-row>

      <b-form-row class="mb-3 align-items-center">
        С
        <b-col>
          <b-form-input size="sm" type="date" v-model="from_date"></b-form-input>
        </b-col>
        <b-col>
          <b-form-input
            size="sm"
            type="time"
            v-model="time_from"
          ></b-form-input>
        </b-col>
          по
          <b-col>
            <b-form-input size="sm" type="date" v-model="to_date"></b-form-input>
          </b-col>
        <b-col>
          <b-form-input size="sm" type="time" v-model="time_to"></b-form-input>
        </b-col>
        <b-col class="col-3">
          <b-dropdown
            id="dropdown-form"
            :text="`Confidence Level ${cl ? cl : ''}`"
            ref="dropdown"
            variant="outline-primary"
            size="sm"
            menu-class="text-nowrap"
          >
            <b-dropdown-form>
              <ConfidenceLevelCard @save-confidence-settings="getCl" />
            </b-dropdown-form>
          </b-dropdown>
        </b-col>

        <b-col
          ><b-button size="sm" variant="outline-primary" type="submit"
            >Искать</b-button
          ></b-col
        >
        <b-col
          ><b-button
            variant="text"
            class="text-danger hp-hover-bg-danger-4 hp-hover-bg-dark-danger float-right"
            @click="clearAll()"
            >Скинуть всё</b-button
          ></b-col
        >
      </b-form-row>
      <b-form-row class="mb-3">
        <b-table
          class="text-nowrap align-items-center"
          id="stats-table"
          :striped="false"
          :sticky-header="true"
          style="min-height: 40vh; max-height: 60vh"
          :no-border-collapse="true"
          :bordered="bordered"
          :borderless="borderless"
          :outlined="outlined"
          :small="small"
          :hover="hover"
          :dark="dark"
          :fixed="fixed"
          :foot-clone="footClone"
          :items="items"
          :current-page="currentPage"
          :fields="fields"
          :head-variant="headVariant"
          :table-variant="tableVariant"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :busy.sync="loading"
          responsive
        >
          <template #head(date)>
            <div class="text-nowrap">Дата</div>
          </template>
          <template #head(from_number)>
            <div class="text-nowrap">Звонящий</div>
          </template>
          <template #head(to_number)>
            <div class="text-nowrap">Принимающий</div>
          </template>
          <template #head(call_id)>
            <div class="text-nowrap">Call ID</div>
          </template>
          <template #head(result)>
            <div class="text-nowrap">Результат</div>
          </template>
          <template #head(smartcpd)>
            <div class="text-nowrap">SmartCPD</div>
          </template>
          <template #head(cl)>
            <div class="text-nowrap">CL</div>
          </template>
          <template #head(record_link)>
            <div class="text-nowrap">Запись</div>
          </template>
          <template #head(reference_link) v-if="is_admin">
            <div class="text-nowrap">Эталон</div>
          </template>
          <template #head(marker)>
            <div class="text-nowrap">Определение</div>
          </template>

          <template #cell(cl)="row">
            <div class="text-nowrap">
              <p v-if="row.item.cl < 30" class="text-danger">
                {{ row.item.cl }}
              </p>
              <p v-else-if="row.item.cl < 60" class="text-primary">
                {{ row.item.cl }}
              </p>
              <p v-else class="text-success">{{ row.item.cl }}</p>
            </div>
          </template>

          <template #cell(record_link)="row">
            <div>
              <b-button
                v-if="row.item.smartcpd && row.item.record_link"
                v-show="row.item.cl"
                pill
                variant="outline-primary"
                size="sm"
                @click="playRecord(row.item, row.item.record_link)"
                class="mr-8"
              >
                <i
                  class="hp-text-color-blue-100 hp-text-color-dark-0 ri-play-fill"
                  style="font-size: 24px"
                ></i>
              </b-button>
            </div>
          </template>
          <template #cell(reference_link)="row">
            <div>
              <b-button
                  v-if="row.item.smartcpd && row.item.reference_link"
                  v-show="row.item.cl"
                pill
                variant="outline-primary"
                size="sm"
                @click="playRecord(row.item, row.item.reference_link)"
                class="mr-8"
              >
                <i
                  class="hp-text-color-blue-100 hp-text-color-dark-0 ri-play-fill"
                  style="font-size: 24px"
                ></i>
              </b-button>
            </div>
          </template>

          <template #cell(marker)="row">
            <div>
              <b-dropdown
                v-if="row.item.smartcpd"
                class="position-static text-nowrap"
                size="sm"
                id="dropdown-1"
                :text="
                  row.item.marker
                    ? 'Успешно'
                    : row.item.marker != null
                    ? 'Ошибка'
                    : 'Нет'
                "
                :variant="
                  row.item.marker
                    ? 'success'
                    : row.item.marker != null
                    ? 'danger'
                    : 'dark'
                "
              >
                <b-dropdown-item-button @click="setMark(row.item, true)"
                  >Успешно</b-dropdown-item-button
                >
                <b-dropdown-item-button @click="setMark(row.item, false)"
                  >Ошибка</b-dropdown-item-button
                >
                <b-dropdown-item-button @click="setMark(row.item, null)"
                  >Не размечен</b-dropdown-item-button
                >
              </b-dropdown>
              <span v-else>Нет записи</span>
            </div>
          </template>
        </b-table>
      </b-form-row>

      <b-form-row>
        <b-col>
          <b-form-row class="align-items-center ml-0">
            <span class="hp-placeholder mr-2">Строк на страницу</span>
            <b-form-select size="sm" class="col-3 float-left" v-model="perPage" @input="updateTable">
              <b-form-select-option :value="10">10</b-form-select-option>
              <b-form-select-option :value="50">50</b-form-select-option>
              <b-form-select-option :value="100">100</b-form-select-option>
              <b-form-select-option :value="200">200</b-form-select-option>
            </b-form-select>
          </b-form-row>
        </b-col>
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            @input="updateTable"
            aria-controls="stats-table"
            size="sm">
          </b-pagination
        ></b-col>
      </b-form-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCol,
  BRow,
  BTable,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormCheckbox,
  BFormSelect,
  BFormSelectOption,
  BInputGroup,
  BButton,
  BFormInput,
  BForm,
  BInputGroupText,
  BInputGroupAppend,
  BFormDatepicker,
  BFormRow,
  BPagination,
  BDropdown,
  BDropdownItemButton,
  BDropdownForm,
  BCard,
  BPopover,
} from "bootstrap-vue";

import axios from "axios";
import ConfidenceLevelCard from "./ConfidenceLevel.vue";

export default {
  props: {
    is_admin: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      fields: [""],
      items: [""],
      striped: true,
      bordered: true,
      borderless: false,
      outlined: true,
      small: true,
      hover: false,
      dark: false,
      fixed: false,
      footClone: false,
      headVariant: null,
      tableVariant: "",
      noCollapse: false,
      currentPage: 1,
      perPage: 50,
      rows: 0,

      sortBy: "date",
      sortDesc: true,

      filter_text: null,
      time_to: null,
      time_from: null,
      from_date: null,
      to_date: null,
      cl: null,
      loading: false,
      downloading: false
    };
  },
  components: {
    BCol,
    BRow,
    BTable,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormCheckbox,
    BFormSelect,
    BFormSelectOption,
    BInputGroup,
    BInputGroupText,
    BButton,
    BFormInput,
    BForm,
    BInputGroupAppend,
    BFormDatepicker,
    BFormRow,
    BPagination,
    BDropdown,
    BDropdownItemButton,
    BDropdownForm,
    BCard,
    BPopover,
    ConfidenceLevelCard,
  },
  methods: {
    async onSubmit(event) {
      event.preventDefault();
      await this.updateTable();
    },
    playRecord(item, url) {
      var audio = new Audio(url);
      audio.play();
    },
    async getPageData(page, perPage) {
       return await this.getStats(page, perPage, true);
    },
    async getStats(page, perPage, paginate) {
      console.log(`getStats(${page}, ${perPage}, ${paginate})`)
      var params = {};
      if (this.from_date) params["from_date"] = this.from_date;
      if (this.to_date) params["to_date"] = this.to_date;
      if (this.time_from) params["from_time"] = this.time_from;
      if (this.time_to) params["to_time"] = this.time_to;
      if (this.filter_text) params["text"] = this.filter_text;
      if (this.cl) params["cl"] = this.cl;
      params["page"] = page;
      params["per_page"] = perPage;
      params["paginate"] = paginate;
      var inn = this.$route.params.inn;
      if (!inn) {
        inn = this.$store.state.user["inn"];
      }
      const url = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/customer/${inn}/stats`;
      if (paginate) {
        const {data} = await axios.get(
            url,
            {
              headers: {
                "Content-Type": "application/json",
              },
              params: params,
            }
        );
        return data;
      } else {
        this.downloading = true;
        try {
            const response = await axios.get(url, {
                headers: {"Content-Type": "text/csv"},
                params: params,
                responseType: "blob"
            });
            // Convert the response into a Blob
            const blob = await response.data;
            // Create a temporary download link
            const downloadUrl = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = "stats.csv";
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              link.remove();
              URL.revokeObjectURL(downloadUrl);
            }, 200)
        } catch (error) {
          console.error("Download error:", error);
        } finally {
          this.downloading = false;
        }
      }
    },
    async updateTable() {
      this.loading = true;
      try {
        console.log(`updateTable: currentPage=${this.currentPage}, perPage=${this.perPage}`);
        const data = await this.getPageData(this.currentPage, this.perPage);
        this.fields = [
          { key: "date", sortable: true },
          { key: "from_number", sortable: true },
          { key: "to_number", sortable: true },
          { key: "call_id", sortable: true },
          { key: "result", sortable: true },
          { key: "smartcpd", sortable: true },
          { key: "cl", sortable: true },
          { key: "record_link", sortable: false },
          { key: "reference_link", sortable: false },
          { key: "marker", sortable: false },
        ];
        if (!this.is_admin) {
            this.fields = this.fields.filter(x => x.key !== "reference_link")
        }
        this.items = data.items;
        const total = (this.perPage * (this.currentPage - 1) + data.items.length) || 0;
        this.rows = (data.items.length === this.perPage) ? total + 1 : total;
        console.log(data.items);
        console.log(this.rows);
      } catch (e) {
        console.error("Can't get stats", e);
        throw e;
      } finally {
        this.loading = false;
      }
    },
    clearAll() {
      this.filter_text = null;
      this.time_to = null;
      this.time_from = null;
      this.date = null;
      this.cl = null;
      this.updateTable();
    },
    getCl(val) {
      this.cl = val;
    },
    async downloadTable() {
      await this.getStats(this.currentPage, this.perPage, false);
    },
    async setMark(item, val) {
      item.marker = val;
      var inn = this.$route.params.inn;
      if (!inn) {
        inn = this.$store.state.user["inn"];
      }
      await axios.post(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/customer/${inn}/stats/mark`,
        {
          item,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      await this.updateTable();
    },
  },
  mounted() {
    this.updateTable();
  },
};
</script>
